import * as React from 'react';

import {
  BooleanField,
  EditButton,
  RecordContextProvider,
  TextField,
  useListContext,
  useTranslate,
} from 'react-admin';
import { Box, Card, CardContent, CardHeader, Typography } from '@mui/material';

import { ISettings } from '../../types';

const MobileGrid = () => {
  const translate = useTranslate();
  const { data, isLoading } = useListContext<ISettings>();

  if (isLoading || data.length === 0) {
    return null;
  }

  return (
    <Box margin="0.5em">
      {data.map((record) => (
        <RecordContextProvider key={record.id} value={record}>
          <Card sx={{ margin: '0.5rem 0' }}>
            <CardHeader title={`${record.name}`} action={<EditButton />} />
            <CardContent sx={{ pt: 0 }}>
              <Typography variant="body2">
                {translate('resources.settings.fields.maintenance')}
                :&nbsp;
                <BooleanField source="maintenance" />
              </Typography>
              <Typography variant="body2">
                {translate('resources.settings.fields.usePayments')}
                :&nbsp;
                <BooleanField source="usePayments" />
              </Typography>
              <Typography variant="body2">
                {translate('resources.settings.fields.useBonuses')}
                :&nbsp;
                <BooleanField source="useBonuses" />
              </Typography>
              <Typography variant="body2">
                {translate('resources.settings.fields.allowSwitchCurrency')}
                :&nbsp;
                <BooleanField source="allowSwitchCurrency" />
              </Typography>
            </CardContent>
          </Card>
        </RecordContextProvider>
      ))}
    </Box>
  );
};

export default MobileGrid;
